import { QueryClient } from '@tanstack/react-query';
import { QueryKeys } from './api/query-keys';
import { debounce } from 'lodash';

async function scheduleWalletDataInvalidationАт(
  queryClient: QueryClient,
  timeout = 0
) {
  setTimeout(async () => {
    await queryClient.invalidateQueries({ queryKey: [QueryKeys.walletBalance] });
    // await queryClient.invalidateQueries({ queryKey: [QueryKeys.vaultTokens] });
    await queryClient.invalidateQueries({ queryKey: [QueryKeys.accountVaultList] });
    // await queryClient.invalidateQueries({ queryKey: [QueryKeys.vaultCtx] });

    // await queryClient.invalidateQueries({ queryKey: [QueryKeys.overviewMetrics] });
    // await queryClient.invalidateQueries({ queryKey: [QueryKeys.overviewHistory] });
  }, timeout);
}

async function scheduleIndexerDataInvalidationFn(
  queryClient: QueryClient,
  timeout = 0
) {
  setTimeout(async () => {
    console.log(`>> Invalidate indexer queries.`)
    queryClient.invalidateQueries({ queryKey: [QueryKeys.vaultHistory] });
    queryClient.invalidateQueries({ queryKey: [QueryKeys.overviewMetrics] });
    queryClient.invalidateQueries({ queryKey: [QueryKeys.overviewHistory] });
  }, timeout);
}

export const scheduleWalletDataInvalidation = debounce(scheduleWalletDataInvalidationАт, 500);
export const scheduleIndexerDataInvalidation = debounce(scheduleIndexerDataInvalidationFn, 500);

export function resetWalletQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: [QueryKeys.walletBalance] });
  queryClient.invalidateQueries({ queryKey: [QueryKeys.walletRunes] });
  // queryClient.invalidateQueries({ queryKey: [QueryKeys.vaultTokens] });
  queryClient.invalidateQueries({ queryKey: [QueryKeys.accountVaultList] });
  // queryClient.invalidateQueries({ queryKey: [QueryKeys.vaultCtx] });
  queryClient.invalidateQueries({ queryKey: [QueryKeys.vaultHistory] });
}